import { api } from '@cma/app'
import { toast } from '@cma/common'
import {
  DestroyBrokerAgentMutation,
  DestroyBrokerAgentMutationVariables
} from '@cma/generated/graphql'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { gql } from 'graphql-request'

export function useDestroyBrokerAgent() {
  const queryClient = useQueryClient()
  return useMutation<
    DestroyBrokerAgentMutation,
    Error,
    DestroyBrokerAgentMutationVariables
  >(
    ({ id }) => {
      const query = gql`
        mutation DestroyBrokerAgent($id: ID!) {
          destroyAgent(id: $id) {
            user {
              name
            }
            errors
          }
        }
      `
      const variables = { id }
      return api({ query, variables })
    },
    {
      async onSuccess(data) {
        await Promise.all([
          queryClient.invalidateQueries(['broker']),
          queryClient.invalidateQueries(['brokerAgents']),
          queryClient.invalidateQueries(['brokerStats'])
        ])
        toast(`${data.destroyAgent?.user?.name} has been deleted.`, {
          variant: 'success'
        })
      }
    }
  )
}
